<template>
    <div class="agent-page">
        <!-- 页面头部 -->
        <div class="page-header">
            <div style="display: flex; flex-direction: column; text-align: start;">
                <h2 class="page-title">{{ projectTitle }}</h2>
                <h2 class="page-title" style="margin-top: 10px;">开标大厅</h2>
            </div>
            <el-button type="primary" icon="el-icon-arrow-left" @click="handleBack">返回项目流程界面</el-button>
        </div>

        <!-- 数据表格 -->
        <div class="table-section">
            <el-table :data="tableData" v-loading="loading" border style="width: 100%" class="data-table">
                <el-table-column label="NO." width="60" align="center">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column prop="sectionName" label="标段名称" show-overflow-tooltip />
                <el-table-column prop="sectionCode" label="标段编号" show-overflow-tooltip />
                <!-- <el-table-column prop="caLockName" label="解密所需CA锁名称(请认真核对所用CA锁是否正确)" show-overflow-tooltip /> -->
                <el-table-column label="开标时间" width="180" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ getOpeningTime(scope.row.timeInfo) }}
                    </template>
                </el-table-column>
                <el-table-column label="解密结束时间" width="180" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ getDecryptEndTime(scope.row.timeInfo) }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="120">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleEnterHall(scope.row)" class="action-btn">
                            开标大厅
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 分页 -->
        <div class="pagination-section">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pagination.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="pagination.total" class="pagination" />
        </div>
    </div>
</template>

<script>
import { getOpeningList } from '@/api/modules/agent'
import { loadProjectDetail } from '@/utils/bid/projectInfo'
import { getOpeningIsMeet } from '@/api/modules/agent'
export default {
    name: 'BidOpeningHall',
    data() {
        return {
            projectTitle: '',
            projectCode: '',
            loading: false,
            tableData: [
            ],
            pagination: {
                currentPage: 1,
                pageSize: 50,
                total: 1
            }
        }
    },
    mounted() {
        this.projectCode = this.$route.query.projectCode
        this.loadData()
        this.getProjectInfo()
    },
    methods: {

        // 获取项目信息
        async getProjectInfo() {
            try {
                this.projectTitle = await loadProjectDetail(this.projectCode)
            } catch (error) {
                console.error('获取项目信息失败:', error)
            }
        },
        // 返回上一页
        handleBack() {
            this.$router.go(-1)
        },
        // 进入开标大厅
        handleEnterHall(row) {
            this.getOpeningIsMeet(row)

        },
        //是否具备进入开标大厅条件
        async getOpeningIsMeet(row) {
            const res = await getOpeningIsMeet(row.sectionCode)
            if (res.code === 200) {
                this.$router.push({ path: '/openHall', query: { projectCode: this.projectCode, sectionCode: row.sectionCode } })
            } else {
                this.$message.error(res.msg)
            }
        },

        // 分页相关方法
        handleSizeChange(val) {
            this.pagination.pageSize = val
            this.loadData()
        },

        handleCurrentChange(val) {
            this.pagination.currentPage = val
            this.loadData()
        },

        getOpeningTime(timeInfo) {
            return this.splitTimeInfo(timeInfo)[0]
        },

        getDecryptEndTime(timeInfo) {
            return this.splitTimeInfo(timeInfo)[1]
        },

        splitTimeInfo(timeInfo) {
            const text = timeInfo ? String(timeInfo) : ''
            if (!text) {
                return ['-', '-']
            }

            let parts = text.split('--')
            if (parts.length < 2) {
                parts = text.split('—')
            }
            if (parts.length < 2) {
                parts = text.split('－')
            }
            if (parts.length >= 2) {
                return [parts[0].trim() || '-', parts.slice(1).join('--').trim() || '-']
            }

            return [text.trim() || '-', '-']
        },

        // 加载数据
        loadData() {
            this.loading = false
            this.getOpeningList()
        },
        //获取开标大厅列表
        async getOpeningList() {
            const res = await getOpeningList(this.projectCode)
            if (res.code === 200) {
                this.tableData = res.data.list
                this.pagination.total = res.data.total
            }
        }
    },


}
</script>

<style lang="less" scoped>
// 引入极简灰度配色公共样式
@import '@/styles/minimal-gray-theme.less';

// ============================================
// 应用极简灰度主题
// ============================================
.agent-page {
    .apply-minimal-gray-theme();
}

// ============================================
// 页面特定样式
// ============================================

// 页面头部（带返回按钮）
.page-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 20px;
    gap: 20px;

    .page-title {
        font-size: 20px;
        font-weight: 600;
        color: @gray-700;
        margin: 0;
        line-height: 1.5;
        position: relative;
        padding-left: 10px;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 3px;
            height: 16px;
            background: @gray-700;
            border-radius: 2px;
        }

        &:first-child::before {
            background: @primary-color;
        }
    }

    /deep/ .el-button {
        transition: all @transition-base ease;

        &:hover {
            transform: translateY(-1px);
        }

        &:active {
            transform: translateY(0);
        }
    }
}
</style>
